export const loginInitialValue = {
    email: "",
    password: "",
    remember_me: false
};
